import { useSelector } from "react-redux";
import { ProductType } from "../../shared/enums/ProductType";
import { StoreState } from "../interfaces/storeState";

export const useProductByType = (productType: ProductType) => {
  const products = useSelector(getProducts);
  return products[productType];
};

const getProducts = (state: StoreState) => {
  return state.products;
};
